<div class="messages flex flex-col" #messages>
  @for (message of chatService.messages(); track message.id) {
  <!--  -->
  @if (message.id !== -1) {
  <app-chat-message
    @fadeInAnimation
    [message]="message"
    [adminFeatures]="features()"
  >
  </app-chat-message>
  }
  <!--  -->
  }
</div>
<!--  -->
<div class="bottom-features">
  @if (showScrollBottomButton()) {
  <button
    [@scroll-bottom]
    (click)="goDown()"
    style="width: 100%"
    class="scroll-bottom button button--style-yellow h-40 padding-x-12"
  >
    Scroll to bottom
  </button>
  }
</div>
